import {Component, inject, OnInit, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {OrganizationSelectComponent} from "@app/common/components/inputs/select/organization-select/organization-select.component"
import {PermissionsService} from "@app/common/services/permissions/permissions.service"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {MatTooltipModule} from "@angular/material/tooltip"
import {RouterModule} from "@angular/router"
import {StateLabel, TemplateTypeLabels} from "@app/platform/models/state-labels"
import {TemplateType, MutationCreateTemplateInput} from "@generated"
import {
    CreateTemplateForTemplateAddDialogGQL,
    CreateTemplateForTemplateAddDialogMutation,
} from "@app/template-editor/components/template-add-dialog/template-add-dialog.generated"
import {mutateThrowingErrors} from "@app/common/helpers/api/mutate"

export type TemplateAddDialogComponentData = MutationCreateTemplateInput

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-add-dialog",
    imports: [FormsModule, MatButtonModule, MatDialogModule, MatInputModule, MatSelectModule, RouterModule, OrganizationSelectComponent, MatTooltipModule],
    templateUrl: "./template-add-dialog.component.html",
    styleUrl: "./template-add-dialog.component.scss",
})
export class TemplateAddDialogComponent implements OnInit {
    readonly onTemplateCreated = output<CreateTemplateForTemplateAddDialogMutation["createTemplate"]>()
    readonly permission = inject(PermissionsService)
    $can = this.permission.$to
    private readonly data = inject<MutationCreateTemplateInput>(MAT_DIALOG_DATA)
    readonly createTemplate = inject(CreateTemplateForTemplateAddDialogGQL)

    readonly dialogRef = inject(MatDialogRef<TemplateAddDialogComponent>)

    readonly $sortedTemplateTypeLabels = signal<StateLabel<TemplateType>[]>([])

    readonly $newItemData = signal<MutationCreateTemplateInput>({...this.data})

    ngOnInit() {
        this.$sortedTemplateTypeLabels.set(Array.from(TemplateTypeLabels.values()).sort((a, b) => a.label.localeCompare(b.label)))
    }

    setNewTemplateOrganization = async (data: {organizationId: string}) => {
        this.$newItemData.update((current) => ({...current, organizationId: data.organizationId}))
    }

    async confirmAction() {
        const {createTemplate: template} = await mutateThrowingErrors(this.createTemplate)({
            input: this.$newItemData(),
        })

        this.onTemplateCreated.emit(template)
        this.dialogRef.close(true)
    }

    cancelAction() {
        this.dialogRef.close(false)
    }

    updateNewItemDataName(name: string): void {
        this.$newItemData.update((r) => ({...r, name}))
    }

    updateNewItemDataTemplateType(templateType: TemplateType): void {
        this.$newItemData.update((r) => ({...r, templateType}))
    }
}
